import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';

export default () => {
  moment.locale('fr');
  Vue.use(vueMoment, { moment });
};
